<div class="sidebar-area bg-white active" [ngClass]="{'active': isSidebarToggled}"
    [class.component-dark-theme]="themeService.isDark()" [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.card-borderd-theme]="themeService.isCardBorder()" [class.rtl-enabled]="themeService.isRTLEnabled()">
    <div class="logo bg-white">
        <a routerLink="/" class="d-flex align-items-center">
            <img src="images/rts-logo.svg" alt="logo-icon">
            <span class="fw-semibold">Epicore</span>
        </a>
    </div>
    <div (click)="toggle()" class="burger-menu" [ngClass]="{'active': isSidebarToggled}">
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>
    <ng-scrollbar visibility="hover">
        <div class="sidebar-inner">
            <div class="sidebar-menu">
                <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">
                                    dashboard
                                </i>
                                <span class="title">
                                    {{ 'Dashboard' | translate }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/presentation-dashboard" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{ 'Main' | translate }}
                                </a>
                            </li>
                            @if (!isB2bCustomer) {
                            <li class="sidemenu-item">
                                <a routerLink="/b2bdashboard" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{"B2B Dashboard" | translate}}
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/old-dashboard" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{'Old Dashboard' | translate}}
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/pie-dashboard" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{'Dashboard with Pie Chart' | translate}}
                                </a>
                            </li>
                            }
                        </ul>
                    </mat-expansion-panel>

                    @if (!isB2bCustomer) {
                    <!-- devices -->
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">
                                    important_devices
                                </i>
                                <span class="title">
                                    {{ 'Plants' | translate }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/plants/all-plant-list" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{ 'All_Plants_List' | translate }}
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                    <!-- users -->
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">
                                    supervisor_account
                                </i>
                                <span class="title">
                                    {{ 'Users' | translate }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/users/users-list" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{ 'Users_List' | translate }}
                                </a>
                            </li>
                            @if(hasRoleAccess(['Identity.User.Create'])) {
                            <li class="sidemenu-item">
                                <a routerLink="/users/add-user" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{ 'Add_User' | translate }}
                                </a>
                            </li>
                            }
                            <li class="sidemenu-item">
                                <a routerLink="/users/user-groups" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{ 'User_Groups' | translate }}
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                    <!-- city list -->
                    <a routerLink="/city-list" class="sidebar-menu-link" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">
                            location_city
                        </i>
                        <span class="title">
                            {{ 'City_List' | translate }}
                        </span>
                    </a>
                    <!-- devices -->
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="material-symbols-outlined">
                                    receipt
                                </i>
                                <span class="title">
                                    {{ 'Invoices' | translate }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/invoices/all-invoices-list" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    {{ 'All_Invoices_List' | translate }}
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                    }
                    
                    <!-- logout -->
                    <div (click)="logout()">
                        <a routerLink="/authentication" class="logout-link sidebar-menu-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">
                            <i class="material-symbols-outlined">
                                logout
                            </i>
                            <span class="title text-danger">
                                {{ 'Logout' | translate }}
                            </span>
                        </a>
                    </div>

                </mat-accordion>
            </div>
        </div>
    </ng-scrollbar>
</div>